<template>
  <div>
    <nav-menu></nav-menu>
    <header class="w3-container modal-wrapper">
      <h2 class="texto-vermelho titulo" >Informações do dispositivo</h2>
    </header>

    <div class="w3-container">
      <div class="w3-col w3-margin-top">
        <span>Dispositivo: </span>
        <strong>{{dados_dispositivo}}</strong>
      </div>

      <div class="w3-col">
        <span>Sistema operacional: </span>
        <strong>{{sistema_operacional}}</strong>
      </div>

      <div class="w3-col">
        <span>Tipo de rede: </span>
        <strong>{{tipo_rede}}</strong>
      </div>
      
      <div class="w3-col modo-lite" v-if="economia_de_dados">
        <span>Isso pode ser um problema: Modo lite ativo</span>
      </div>


      <div class="w3-col">
        <span>Velocidade de download: </span><strong>{{velocidade_download}}</strong>
      </div>

      <div class="w3-col">
        <span>Latência: </span><strong>{{latencia}}</strong>
      </div>
    </div>

    <div class="w3-col w3-center">
      <button @click="simularLog()" class="w3-btn w3-theme">Simular log</button>
    </div>

    <div class="w3-col w3-center">
      <button @click="enviarLogsADMServicos()" class="w3-btn w3-theme">Enviar logs</button>
    </div>
  </div>
</template>

<script>
  import NavMenu from '@/components/Menu'
  import store from '@/ambiente/store'
  import toastr from 'toastr'
  import RLogADMServicos from '@/components/Rest/RLogADMServicos'
  import moment from "moment"
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  
  export default {
    name: 'LogsADMServicos',
    components: {    
      NavMenu
    },

    data() {
      return {
        dados_dispositivo: '',
        geolocalizacao: '',
        tipo_rede: '',
        economia_de_dados: '',
        sistema_operacional: '',
        velocidade_download: '',
        latencia: ''
      };
    },

    created() {
      this.dados_dispositivo = Biblioteca.buscarDadosDispositivo();
      this.sistema_operacional = Biblioteca.buscarSistemaOperacionalDispositivo();
      this.tipo_rede = Biblioteca.buscarTipoRedeDispositivo();
      this.economia_de_dados = Biblioteca.buscarModoEconomiaDadosDispositivo();
      this.geolocalizacao = Biblioteca.buscarGeolocalizacaoDispositivo();
      this.velocidade_download = Biblioteca.buscarVelocidadeDownloadDispositivo();
      this.latencia = Biblioteca.buscarDadosLatenciaDispositivo();
    },

    methods: {
      enviarLogsADMServicos() {
        RLogADMServicos.enviarLogsADMServicos();
      },

      simularLog() {
        
      }
    }
  }
</script>

<style scoped> 
  .modo-lite {
    color: red;
    font-weight: bolder;
  }
</style>


// WEBPACK FOOTER //
// src/components/LogsADMServicos.vue